import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = {
    key: "actions",
    class: "float-end"
};
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Change Secret", -1 /* HOISTED */);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* HOISTED */);
const _hoisted_17 = { class: "form-contents" };
const _hoisted_18 = { class: "row" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("div", { class: "col-xs-12 col-sm-12" }, null, -1 /* HOISTED */);
const _hoisted_20 = {
    key: "profile-panel",
    class: "col-xs-12 col-sm-12"
};
const _hoisted_21 = {
    key: "profile",
    class: "clearfix"
};
const _hoisted_22 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_23 = { class: "col-xs-12 col-sm-12" };
const _hoisted_24 = { class: "float-end" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", null, "Last Active", -1 /* HOISTED */);
const _hoisted_26 = { class: "clearfix" };
const _hoisted_27 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_29 = { class: "invalid-feedback" };
const _hoisted_30 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12 bottom10"
};
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tAPI secret initials\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_32 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tToken Lifetime (minutes) *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_34 = { class: "invalid-feedback" };
const _hoisted_35 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tMapped Principal\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_38 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tDescription\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_40 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\tThis is your new API secret token\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_42 = { class: "d-flex bottom10" };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-clipboard",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("span", null, "Copy the token; once this form has been closed, it cannot be retrieved again.", -1 /* HOISTED */);
const _hoisted_45 = { class: "float-end float-start-sm" };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isApplicationArchived })
                }, _toDisplayString(_ctx.pageTitle || 'Missing user name...'), 3 /* TEXT, CLASS */)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "primary",
                            onClick: _ctx.save
                        }, {
                            default: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createTextVNode(),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "danger",
                            onClick: _ctx.archive
                        }, {
                            default: _withCtx(() => [
                                _hoisted_9,
                                _hoisted_10
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewApplication && !_ctx.isApplicationArchived]
                        ]),
                        _createTextVNode(),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "warning",
                            onClick: _ctx.restore
                        }, {
                            default: _withCtx(() => [
                                _hoisted_11,
                                _hoisted_12
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewApplication && _ctx.isApplicationArchived]
                        ]),
                        _createTextVNode(),
                        _withDirectives(_createVNode(_component_b_button, {
                            type: "button",
                            variant: "warning",
                            onClick: _ctx.changeSecret
                        }, {
                            default: _withCtx(() => [
                                _hoisted_13,
                                _hoisted_14
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]), [
                            [_vShow, !_ctx.isNewApplication]
                        ]),
                        _createTextVNode(),
                        _createVNode(_component_b_button, {
                            type: "button",
                            variant: "secondary",
                            onClick: _ctx.goBack
                        }, {
                            default: _withCtx(() => [
                                _hoisted_15,
                                _hoisted_16
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"]),
                _createTextVNode(),
                _hoisted_19,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d;
                            return [
                                _createElementVNode("div", _hoisted_21, [
                                    (_ctx.appHasLoggedIn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _hoisted_25,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.whenLastActiveString), 1 /* TEXT */)
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _hoisted_28,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                type: "text",
                                                modelValue: _ctx.application.applicationName,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.application.applicationName) = $event)),
                                                modelModifiers: { trim: true },
                                                name: "applicationName",
                                                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name },
                                                maxlength: "100"
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_29, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter an application name\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.name]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        (!_ctx.isNewApplication && _ctx.application.applicationSecret && !_ctx.newSecret)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                _hoisted_31,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    modelValue: _ctx.application.applicationSecret,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.application.applicationSecret) = $event)),
                                                    modelModifiers: { trim: true },
                                                    name: "applicationSecret",
                                                    maxlength: "100",
                                                    disabled: ""
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_32, [
                                            _hoisted_33,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.tokenVal, {
                                                type: "number",
                                                modelValue: _ctx.application.tokenLifetime,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.application.tokenLifetime) = $event)),
                                                modelModifiers: { trim: true },
                                                name: "applicationSecret",
                                                class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.token },
                                                min: "60",
                                                step: "30"
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_34, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a token lifetime (minutes)\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.token]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_35, [
                                            _hoisted_36,
                                            _createTextVNode(),
                                            _createVNode(_component_b_alert, {
                                                variant: "primary",
                                                dismissible: "",
                                                modelValue: _ctx.showInfoMessage,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.showInfoMessage) = $event))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tYou can map an application account to a user principal, granting the application the same permissions as the user.\r\n\t\t\t\t\t\t\t\t\t\t\t"),
                                                    _hoisted_37,
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tThis is recommended for integrations that manufacture data linked to companies and systems.\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"]),
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, {
                                                name: "userPrincipal",
                                                modelValue: _ctx.userPrincipal,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.userPrincipal) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: _ctx.selectPlaceholder,
                                                options: _ctx.users,
                                                showLabels: false
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_38, [
                                            _hoisted_39,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_textarea, {
                                                name: "description",
                                                modelValue: _ctx.application.applicationDescription,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.application.applicationDescription) = $event)),
                                                rows: "5"
                                            }, null, 8 /* PROPS */, ["modelValue"])
                                        ])
                                    ])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            id: "newToken",
            modelValue: _ctx.showNewAPISecret,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.showNewAPISecret) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tNew API Secret\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.showNewAPISecret = false))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_46,
                            _createTextVNode(" Close\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.newSecret,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.newSecret) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "applicationSecret",
                                    maxlength: "100",
                                    readonly: ""
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _createTextVNode(),
                                _createVNode(_component_b_button, {
                                    class: "m-0 ms-2",
                                    type: "button",
                                    variant: "primary",
                                    onClick: _ctx.copyToClipboard,
                                    title: "Copy to clipboard"
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_43
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"])
                            ]),
                            _createTextVNode(),
                            _hoisted_44
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
